<template>
  <v-app v-if="browserSize === `desktop`">
    <div class="finances-element">
       <div class="my-table my-2">
         salaaaaaaaaaaaaaaaaaam
        <div class="head">
          <div
            v-for="head_item in heads"
            :key="head_item"
            class="head_item title-blue d-inline-block"
          >
            <div class="inner-item">
              {{ head_item }}
            </div>
          </div>
        </div>

        <div v-if="accounting" class="body-table">
          <div
            v-for="table_row in accounting"
            :key="table_row"
            class="body-row"
          >
            <div v-if="!table_row.seller_accounting_id">
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ jalali_date(table_row.created_at) }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.id }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                  <!-- <Etiquette :status="parseInt(table_row.status)"></Etiquette> -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.payable }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.discount }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.delivery_cost }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.golpino_commission }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.seller_income }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
            </div>
            <div v-if="table_row.seller_accounting_id">
              <div class="head_item item d-inline-block">
                <div class="inner-item">
                  {{ jalali_date(table_row.created_at) }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.id }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.desc }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">{{ table_row.value }} تومان</div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div
                  v-if="table_row.status == 1"
                  class="inner-item text-primary"
                >
                  برداشت گلپینو
                </div>
                <div
                  v-if="table_row.status == 0"
                  class="inner-item text-danger"
                >
                  واریز گلپینو
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div v-if="table_row.status == 1" class="inner-item">
                  {{ table_row.value }} تومان
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div v-if="table_row.status == 0" class="inner-item">
                  {{ table_row.value }} تومان
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div v-if="the_accounting">
          <div v-for="(table_row, index) in the_accounting" :key="index">

          </div>
        </div> -->
      </div>
     
    </div>
  </v-app>
</template>

<script>
import jalalim from "jalali-moment";
import Service from "../../../utils/seller-service";

export default {
  name: "FinanceDeskView",
  props: ["transaction", "browserSize"],

  data: () => ({
    my_modal: false,
  }),
  methods: {
    jalali_date: (this_date) => {
      return jalalim(this_date).locale("fa").format("YYYY/MM/DD");
    },
  },
  computed: {
    authService: function () {
      return Service(true);
    },
    theService: function () {
      return Service(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.wallet-part {
  vertical-align: middle;
  width: 20%;
  position: relative;
  .wallet-wrapper {
    margin: 0 auto;
    width: 50px;
    img {
      width: 100%;
    }
  }
}
.text-part {
  width: 50%;
  vertical-align: middle;
}
.details-part {
  width: 30%;
  vertical-align: middle;
}

.card-wrapper {
  // margin-left: -3px;
  // margin-right: -3px;
}

.details {
  padding: 0 4px;
  button {
    border: solid 2px #d5cdff;
    border-radius: 10px;
    padding: 7px 15px;
    font-size: 12px;
    width: 100%;
    color: #7d6cd5;
    font-weight: 500;
  }
}
.dates {
  font-size: 12px;
  font-weight: 500;
  color: gray;
}
.number-accounts {
  color: palevioletred;
}
</style>